import React from 'react';
import { Quote } from 'lucide-react';

export default function FounderCard({ founder, variant = 'red' }) {
  const shadowClass = variant === 'red' ? 'paper-shadow-red' : 'paper-shadow-teal';
  return (
    <article className={`relative bg-white border-2 border-[#2C3E50] rounded-3xl p-7 lg:p-9 ${shadowClass} hover:-translate-y-1`}>
      <Quote
        className="absolute -top-5 -left-2 text-white bg-[#2C3E50] rounded-full p-1 border-2 border-[#2C3E50]"
        size={38}
      />
      <div className="flex items-center gap-4">
        <div
          className="w-20 h-20 rounded-2xl border-2 border-[#2C3E50] flex items-center justify-center text-white font-black text-2xl paper-shadow-sm"
          style={{ background: founder.accent, fontFamily: 'Fraunces, serif' }}
        >
          {founder.initials}
        </div>
        <div>
          <h3 className="text-2xl font-black text-[#2C3E50] leading-tight" style={{ fontFamily: 'Fraunces, serif' }}>
            {founder.name}
          </h3>
          <div className="text-sm font-bold uppercase tracking-widest" style={{ color: founder.accent }}>
            {founder.role} &middot; Pikachu Classes
          </div>
        </div>
      </div>

      <div className="mt-5 inline-block bg-[#FFF8EC] border-2 border-[#2C3E50] rounded-full px-3 py-1 text-xs font-black uppercase tracking-widest text-[#2C3E50]">
        {founder.focus}
      </div>

      <p className="mt-5 text-[#2C3E50]/85 font-medium leading-relaxed">{founder.bio}</p>

      <div className="mt-6 flex flex-wrap gap-2">
        {founder.tags.map((t) => (
          <span
            key={t}
            className="px-3 py-1 rounded-md text-xs font-black text-[#2C3E50] bg-[#F4B93E]/40 border border-[#2C3E50]/20"
          >
            {t}
          </span>
        ))}
      </div>
    </article>
  );
}
